import { createAction, props } from '@ngrx/store';
import { IIntroductionData, IIntroductionModel } from '@partners/api';

export class IntroductionActions {
  static reset = createAction('[Introduction] Reset State');
  static load = createAction('[Introduction] Load');
  static loadSuccess = createAction(
    '[Introduction] Load Success',
    props<{ model: IIntroductionModel; data: IIntroductionData }>()
  );
  static loadFailure = createAction('[Introduction] Load Failure', props<{ error: any }>());
  static submit = createAction('[Introduction] Submit');
  static submitSuccess = createAction('[Introduction] Submit Success', props<{model: IIntroductionModel; data: IIntroductionData }>());
  static submitFailure = createAction('[Introduction] Submit Failure', props<{ error: any }>());
}
